interface AnswerRow {
  answer: string;
  correct: string;
  type: string;
}

export const ExamResultsToHTML = (data: any) => {
  if (data.summary_tables) {
    data.summary_tables = [
      data.summary_tables[0],
      data.summary_tables[2],
      data.summary_tables[4],
      data.summary_tables[6],
      data.summary_tables[1],
      data.summary_tables[3],
    ];
  }
  return (
    <div className="resultsPage">
      <div className="pageContent results">
        <table>
          <tr>
            <td>
              <div className="headline">
                <h1>Your Results</h1>
                <h2>
                  <span>Name:</span> {data.userName} <br />{" "}
                  <span>Test Date:</span> {data.testDate}
                </h2>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <h2>
                      {data?.decision?.toString() === "both"
                        ? `You performed equally well on the SAT and ACT portions of this diagnostic.`
                        : `You're Better-Suited to ${data?.decision}!`}
                    </h2>
                  </td>
                </tr>
                <tr>
                  <td>
                    <table className="resultsHolder">
                      <tr>
                        <td className="resultsBox">
                          <div
                            className={[
                              "headline",
                              data?.decision === "the ACT" ? "active" : "",
                            ].join(" ")}
                          >
                            {data?.decision === "the ACT" && (
                              <img
                                src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                alt="checkmark"
                              />
                            )}
                            ACT Composite:{" "}
                            <span>{data?.act_summary?.act_score}</span>
                            <p
                              className="equivalentHeader"
                              style={{
                                fontSize: "18px",
                                padding: "0px",
                                margin: "0px",
                              }}
                            >
                              SAT Equivalent:{" "}
                              <span style={{ fontSize: "18px" }}>
                                {data.satEquivalent}
                              </span>
                            </p>
                            {/* <span>({data?.act_summary?.sat_score} SAT)</span> */}
                          </div>
                          <div className="subheadline">
                            {data?.legacyACTScoring
                              ? `Your ACT Composite score is the average of your scores on each of the three sections of the ACT: English, Math, Reading and Science.`
                              : `Your ACT composite score is the average of your scores on the English, Math, and Reading sections. Your Science score is reported separately and is not included in your composite score.`}
                          </div>
                          <div className="resultsTable">
                            <div className="resultsRow">
                              <p>English:</p>
                              <p style={{ color: "#000" }}>
                                {data?.act_summary?.details.english}
                              </p>
                            </div>
                            <div className="resultsRow">
                              <p>Math:</p>
                              <p style={{ color: "#000" }}>
                                {data?.act_summary?.details.math}
                              </p>
                            </div>
                            <div className="resultsRow">
                              <p>Reading:</p>
                              <p style={{ color: "#000" }}>
                                {data?.act_summary?.details.reading}
                              </p>
                            </div>
                            {data?.legacyACTScoring && (
                              <div className="resultsRow">
                                <p>Science:</p>
                                <p style={{ color: "#000" }}>
                                  {data?.act_summary?.details.science}
                                </p>
                              </div>
                            )}
                          </div>
                          {!data?.legacyACTScoring && (
                            <div className="resultsTable bottomTable">
                              <div className="resultsRow">
                                <p>Science:</p>
                                <p style={{ color: "#000" }}>
                                  {data?.act_summary?.details.science}
                                </p>
                              </div>
                              <div className="resultsRow textOnly">
                                <p
                                  style={{
                                    color: "#000",
                                    fontWeight: 500,
                                  }}
                                >
                                  The Science score is not included in the
                                  Composite score.
                                </p>
                              </div>
                            </div>
                          )}
                        </td>
                        <td className="resultsBox">
                          <div
                            className={[
                              "headline",
                              data?.decision === "the SAT" ? "active" : "",
                            ].join(" ")}
                          >
                            {data?.decision === "the SAT" && (
                              <img
                                src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                alt="checkmark"
                              />
                            )}
                            SAT Total Score:{" "}
                            <span>{data?.sat_summary?.sat_score}</span>
                            <p
                              className="equivalentHeader"
                              style={{
                                fontSize: "18px",
                                padding: "0px",
                                margin: "0px",
                              }}
                            >
                              ACT Equivalent:{" "}
                              <span style={{ fontSize: "18px" }}>
                                {data.actEquivalent}
                              </span>
                            </p>
                            {/* <span>({data?.sat_summary?.act_score} ACT)</span> */}
                          </div>
                          <div className="subheadline">
                            Your SAT Total Score is the sum of your scores on
                            the Reading and Writing and the Math portions of the
                            SAT.
                          </div>
                          <div className="resultsTable active">
                            <div className="resultsRow">
                              <p>Reading and Writing:</p>
                              <p style={{ color: "#000" }}>
                                {data?.sat_summary?.details.verbal}
                              </p>
                            </div>
                            <div className="resultsRow">
                              <p>Math:</p>
                              <p style={{ color: "#000" }}>
                                {data?.sat_summary?.details.math}
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td>
              <hr />
            </td>
          </tr>
        </table>
        <table className="answersMatrix">
          <tr>
            <td colSpan={2}>
              <div className="headline">
                ACT <span>Answers</span>
              </div>
              <div className="subheadline">
                Below is a detailed accounting of your performance on each of
                the four sections of the ACT portion of our diagnostic test. In
                each section, you’ll see the number of each question, the
                correct answer, your answer, and the Question Category it
                belongs to.
              </div>
            </td>
          </tr>
          <tr>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              English:{" "}
                              <span>{data?.act_summary?.details.english}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.english.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Math:{" "}
                              <span>{data?.act_summary?.details.math}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.math.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Reading:{" "}
                              <span>{data?.act_summary?.details.reading}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.reading.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table className="matrixColumn" style={{ width: "100%" }}>
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Science:{" "}
                              <span>{data?.act_summary?.details.science}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.act_answers?.science.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <hr />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <div className="headline">
                SAT <span>Answers</span>
              </div>
              <div className="subheadline">
                Below is a detailed accounting of your performance on each of
                the sections of the SAT portion of our diagnostic test. In each
                section, you’ll see the number of each question, the correct
                answer, your answer, and the Question Category it belongs to.
              </div>
            </td>
          </tr>
          <tr>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table
                      className="matrixColumn sat"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Reading and Writing:{" "}
                              <span>{data?.sat_summary?.details.verbal}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="matrixHeadline subheadline">
                            Module 1
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.sat_answers?.verbal.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="matrixHeadline subheadline">
                            Module 2
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.sat_answers?.verbal2.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
            <td width={"50%"} valign="top">
              <table className="matrixTable">
                <tr>
                  <td>
                    <table
                      className="matrixColumn sat"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <td colSpan={2}>
                          <div className="matrixHeadline">
                            <p>
                              Math:{" "}
                              <span>{data?.sat_summary?.details.math}</span>
                            </p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="matrixHeadline subheadline">
                            Module 1
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.sat_answers?.math.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div className="matrixHeadline subheadline">
                            Module 2
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <table>
                            <tr
                              className="matrixData"
                              style={{ backgroundColor: "#bad7a7" }}
                            >
                              <td className="matrixDataCol">
                                {" "}
                                <p>Question #</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Your Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Correct Answer</p>
                              </td>
                              <td className="matrixDataCol">
                                <p>Question Category</p>
                              </td>
                            </tr>
                            {data?.sat_answers?.math2.map(
                              (item: AnswerRow, index: number) => {
                                return (
                                  <tr className="matrixData">
                                    <td className="matrixDataCol">
                                      <p>{index + 1}</p>
                                    </td>
                                    {item.answer ? (
                                      <td className="matrixDataCol">
                                        <p>{item.answer}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol unanswered">
                                        <p>{item.answer}</p>
                                      </td>
                                    )}
                                    {item.correct !== item.answer ? (
                                      <td className="matrixDataCol incorrect">
                                        <p>{item.correct}</p>
                                      </td>
                                    ) : (
                                      <td className="matrixDataCol">
                                        <img
                                          src="https://testing.firstchoiceprep.com/wp-content/uploads/2023/11/checkmark.png"
                                          alt="check"
                                        />
                                      </td>
                                    )}

                                    <td className="matrixDataCol">
                                      <p>{item.type}</p>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <table className="summary-table">
          <tr
            className="summary-table-headline"
            style={{ backgroundColor: "#7AAE4E" }}
          >
            <td>
              <h4>Performance Summary</h4>
              <p>
                Below is a detailed accounting of how well you performed on each
                of the Question Categories on our diagnostic test. This will
                help you determine the specific skills and question types you’ll
                need to improve upon to get to mastery.
              </p>
            </td>
          </tr>
          <tr
            className="summary-table-holder"
            style={{ backgroundColor: "#7AAE4E" }}
          >
            <td>
              {(data?.summary_tables).map((item: any, index: number) => {
                if (!item) return <span></span>;
                return (
                  <table className="summaryTable" key={Math.random()}>
                    <tr
                      className="headline"
                      style={{ backgroundColor: "#7AAE4E" }}
                    >
                      <td>{item.table_name}</td>
                    </tr>

                    {Object.keys(item?.categories).map((row: any) => {
                      return (
                        <tr
                          className="tableHolder"
                          style={{ backgroundColor: "#7AAE4E" }}
                        >
                          <td>
                            <table>
                              <tr>
                                <td
                                  className="tableRow"
                                  style={{
                                    display: "inline-block",
                                    padding: "4px",
                                  }}
                                >
                                  <img
                                    src={`https://testing.firstchoiceprep.com/wp-content/plugins/firstchoiceprep-api/images/numbers/${Math.round(
                                      item.categories[row].value
                                    )}.png`}
                                    alt="donut"
                                    width={80}
                                    height={80}
                                  />
                                </td>
                                <td
                                  className="tableRow"
                                  style={{
                                    display: "inline-block",
                                    padding: "4px",
                                  }}
                                >
                                  <p
                                    className="catName"
                                    style={{ margin: "0px" }}
                                  >
                                    {item.categories[row].title}:{" "}
                                  </p>
                                </td>
                                <td
                                  className="tableRow"
                                  style={{
                                    display: "inline-block",
                                    padding: "4px",
                                  }}
                                >
                                  <p>
                                    <span>{item.categories[row].correct}</span>{" "}
                                    correct out of{" "}
                                    {item.categories[row].correct +
                                      item.categories[row].incorrect}
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      );
                    })}
                  </table>
                );
              })}
            </td>
          </tr>
        </table>
        {/* <div className="pageContent results">
        
          
      </div> */}
      </div>
    </div>
  );
};
